import React from 'react'
import { SingleSelectionGroup } from '@paypalcorp/pp-react'
import { getLocalizedContent } from '../helper'

const SelectionGroup = (props) => {
  return (
    <React.Fragment>
      <SingleSelectionGroup
        name={props.name}
        id={props.id}
        className={props.className}
        label={props.label}
        hideLabel={props.hideLabel}
        value={props.value}
        options={props.options.map((t) => ({
          label: getLocalizedContent(t.labelKey),
          value: t.value,
        }))}
        responsive="xs"
        onChange={props.onChange}
        style={props.style}
      />
    </React.Fragment>
  )
}

export default SelectionGroup
